function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M98.1572 194.343L107.729 266.427L119.696 265.654L122.485 194.343H98.1572Z",
  fill: "#F6B9A6"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.02637 265.58H14.7611L37.1852 208.574L11.83 203.563L4.02637 265.58Z",
  fill: "#F6B9A6"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M120.089 39.397C119.164 29.2965 119.019 12.5519 117.877 0H57.1147L76.1038 68.7662C76.9951 83.3347 79.3491 97.8138 83.1177 111.915C85.6216 121.283 88.7591 130.54 89.9317 140.166C90.8125 147.391 90.568 154.698 90.6845 161.974C90.9308 177.509 93.248 193.148 96.1577 208.391C99.0156 223.36 100.721 238.652 103.411 253.755C109.909 253.762 116.408 253.768 122.906 253.774C123.431 253.775 124.01 253.754 124.388 253.392C124.778 253.018 124.812 252.415 124.82 251.873C125.444 209.292 124.829 166.807 123.791 124.067C123.699 120.304 123.608 116.541 123.516 112.778C122.92 88.2995 122.322 63.7926 120.089 39.397Z",
  fill: "#3A3A6A"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M36.4996 0C37.8624 21.1003 43.3207 41.4618 42.5337 62.9793C42.3225 68.7408 43.0025 75.6092 45.1664 80.9263C45.2549 81.1454 45.3434 81.3987 45.2356 81.6082C45.1182 81.8351 44.8334 81.9 44.5923 81.9859C43.5801 82.3461 42.9596 83.5599 43.262 84.5923C43.4197 85.1296 43.7913 85.6431 43.6914 86.1935C43.6423 86.4652 43.4828 86.7018 43.3268 86.9297C40.4496 91.1645 37.9483 95.6657 35.8949 100.356C34.0702 104.523 33.8345 108.822 32.0282 112.964C27.357 123.672 23.2905 134.546 19.4167 145.566C16.4589 153.981 13.4914 162.431 11.7701 171.183C6.44508 198.255 1.65027 225.868 0 253.433C7.37407 253.376 14.7473 253.318 22.1213 253.259C22.9977 253.252 23.939 253.225 24.6445 252.705C25.2343 252.27 25.5525 251.568 25.8443 250.895C35.2709 229.187 41.8667 206.777 48.3924 184.062C51.3617 173.722 54.3476 163.336 58.8558 153.569C77.4198 113.345 87.9481 69.6785 95.2126 26.2588C96.5368 18.3458 99.7874 8.72198 100.918 0H36.4996Z",
  fill: "#4C4981"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M155.904 272.801C155.907 272.714 155.909 272.626 155.908 272.539C155.868 267.741 150.148 266.325 146.55 265.041C139.59 262.558 132.79 259.464 125.942 256.684C123.99 255.891 122.163 255.564 120.166 256.399C119.149 256.823 118.346 257.625 117.454 258.269C114.173 260.64 108.902 260.875 106.062 257.611C105.787 257.295 105.554 256.932 105.204 256.7C104.855 256.468 104.335 256.416 104.051 256.724C103.541 257.274 103.484 259.553 103.326 260.293C103.001 261.822 102.803 263.371 102.685 264.928C102.464 267.84 102.54 270.767 102.616 273.684C102.633 274.366 102.661 275.08 103.005 275.668C103.793 277.017 107.206 276.68 108.592 276.728C110.787 276.802 112.985 276.801 115.181 276.784C118.396 276.758 121.613 276.604 124.827 276.604C130.971 276.604 137.113 276.48 143.255 276.381C146.411 276.329 149.597 276.425 152.747 276.265C154.751 276.163 155.826 274.66 155.904 272.801Z",
  fill: "#873465"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M53.3648 272.801C53.3683 272.714 53.3701 272.626 53.3692 272.539C53.3289 267.741 47.6086 266.325 44.011 265.041C37.0514 262.558 30.2505 259.464 23.4032 256.684C21.4506 255.891 19.6241 255.564 17.6268 256.399C16.6102 256.823 15.8074 257.625 14.9152 258.269C11.634 260.64 6.36326 260.875 3.52283 257.611C3.24764 257.295 3.01451 256.932 2.66483 256.7C2.31602 256.468 1.79631 256.416 1.51148 256.724C1.00229 257.274 0.944447 259.553 0.786694 260.293C0.462425 261.822 0.263481 263.371 0.146043 264.928C-0.0748112 267.84 0.000559591 270.767 0.0768068 273.684C0.0943349 274.366 0.121503 275.08 0.46593 275.668C1.25382 277.017 4.66741 276.68 6.05301 276.728C8.2484 276.802 10.4455 276.801 12.6418 276.784C15.8573 276.758 19.0737 276.604 22.2884 276.604C28.432 276.604 34.5738 276.48 40.7157 276.381C43.8716 276.329 47.0582 276.425 50.208 276.265C52.2115 276.163 53.2868 274.66 53.3648 272.801Z",
  fill: "#873465"
});

var SvgLegs2 = function SvgLegs2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 156,
    height: 277,
    viewBox: "0 0 156 277",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLegs2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/legs-2.d58059a1.svg";
export { ForwardRef as ReactComponent };